export default "__VITE_ASSET__CNhpSgdR__"